import { Component } from '@angular/core';
import { NotificaAttivita } from '../../models/notifica-attivita';
import { NotificaAttivitaResponse } from '../../models/notifica-attivita-response';
import { OperationsService } from '../../services/operations.service';
import { ViewManagerService } from '../../services/view-manager-service';

@Component({
    selector: 'main [notifications-view]',
  templateUrl: 'notifications-view.component.html',
  host: { '[attr.id]': '\'content\'' }
})

export class NotificationsViewComponent {
  notifiche: NotificaAttivita[] = [];
  notificheResponse: NotificaAttivitaResponse;
  numToViewNotifiche: number = 0;
  constructor(protected operationService: OperationsService,
              private viewManager: ViewManagerService) {}

  ngOnInit() {
    this.viewManager.svuotaMenu();
    this.loadProssimeNotifiche();
  }

  loadProssimeNotifiche() {
    this.operationService.prendiNotificheAttivitaPaginate({fromResult: this.notifiche.length}).
      subscribe(response => this.notifichePrese(response));
  }

  notifichePrese(response: NotificaAttivitaResponse) {
    this.notificheResponse = response;
    this.notifiche = this.notifiche.concat(response.notifiche);
  }

  notificaEliminata() {
    if (this.notificheResponse && this.notificheResponse.numeroNotificheTotali > 0) {
      this.notificheResponse.numeroNotificheTotali = this.notificheResponse.numeroNotificheTotali - 1;
    }
  }
}
